import { Injectable } from '@angular/core';
import {CreateSchool} from '@interfaces/requests/create-school';
import {HttpClient, HttpEventType, HttpEvent, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from '@node_modules/rxjs/Observable';
import {User} from '@models/user';
import {AuthFacade} from '@facades/auth/authFacade';
import * as SpinnerReducer from '@store/spinner/reducers';
import * as AuthReducer from '@store/auth/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {OnDestroy} from '@node_modules/@angular/core';
import {School} from '@models/shool';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';


@Injectable()
export class SchoolService implements OnDestroy{
  user: User;
  subscribes = [];

  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>,
    private router: Router
  ) {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        const user = AuthFacade.getUser();
        // console.log(user);
        if (user) {
          this.user = user;
        }
      }
    ));
  }
  ngOnDestroy() {
    this.unsubscribe();
  }
  create(body: CreateSchool) {
    // console.log(body);
    return this.httpClient.post('school', body);
  }
  update(body: any) {
    console.log(body);
    if (this.user.activeSchool && this.user.role != 'super_admin') {
      const school_id = this.user.activeSchool;
      return this.httpClient.put(school_id + '/school' , body);
    }
    else if (this.user.role == 'super_admin') {
      const school_id = body.id;
      return this.httpClient.put(school_id + '/school' , body);
    }
    return new Observable();
  }

  postFile(fileToUpload: File, school_id?: number) {
    // this is the important step. You need to set content type as null
    let id = this.user.activeSchool;
    if (school_id != undefined) {
      id = school_id;
    }
    if (id) {
      const formData: FormData = new FormData();
      formData.append('terms', fileToUpload, fileToUpload.name);
      // formData.append('school_id', id);
      return this.httpClient.post('school/termsUpload', formData);
    }
    return new Observable();
  }

  uploadFile(formData) {
    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    // this is the important step. You need to set content type as null
     return this.httpClient.post('school/termsUpload', formData
    ,
    {
      reportProgress: true,
      observe: 'events',
    }).pipe(
      map(event => this.getEventMessage(event, formData)),
      catchError(this.handleError)
    ).subscribe(events => {
      if (events.type == HttpEventType.UploadProgress) {
          console.log('Upload progress: ', Math.round(events.loaded / events.total * 100) + '%');
      } else if(events.type === HttpEventType.Response) {
          console.log(events);
      }
    });
  }

  private getEventMessage(event: HttpEvent<any>, formData){

    switch(event.type) {
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event);

      case HttpEventType.Response:
        return this.apiResponse(event);

      default:
        return `File Upload event: ${event.type}`;
    }
  }

  private fileUploadProgress (event) {
    const percentDone = Math.round(100 * event.loaded / event.total);
    return { status: 'progress', message: percentDone };
  }

  private apiResponse (event) {
    return event.body;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Error occured " + error.error.message);
    } else {
      console.log("Backend returned error " + $(error.error));
    }

    return throwError('Something Bad Happened');
  }

  getSameSchoolsBySchedule(user_id: string) {
    return this.httpClient.post('school/schoolsSchedule', {user_id: user_id});
  }

  getSchool(school_id: number) {
    if (school_id) {
      return this.httpClient.get('school/' + school_id);
    }
  }

  getAllSchools(page = 1) {
      return this.httpClient.get('school' + this.router.url + '?page=' + page);
  }

  getSchoolListData() {
    return this.httpClient.get('school/all-data');
  }

  deleteSchoolById(body: {id: number}) {
    return  this.httpClient.delete('school/' + body.id);
  }

  exportSchoolData(schoolId: number) {
    return this.httpClient.get('school/' + schoolId + '/export-data', {responseType: 'blob'});
  }

  getOwner(school_id: number) {
    return this.httpClient.get('school/' + school_id + '/get-owner');
  }

  getUsers(school_id: number, page, programId = null, classId = null, selectedCurriculumId = null, mode) {
    let url = 'school/users/' + school_id + '?page=' + page + '&mode=' + mode;
    if (programId) {
      url += '&program_id=' + programId;
    }
    if (classId) {
      url += '&class_id=' + classId;
    }
    if (selectedCurriculumId) {
      url += '&curriculum_id=' + selectedCurriculumId;
    }
    return this.httpClient.get(url);
  }

  addUserToSchool(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      body['school_id'] = school_id;
      return this.httpClient.post(school_id + '/school/addUser' , body);
    }
    return new Observable();
  }

  removeUserFromSchool(schoolId: number, userId: number, removalReason = 'admin_student_page') {
    if (schoolId && userId) {
      return this.httpClient.delete(
        schoolId + '/school/user/' + userId + '?removal_reason=' + encodeURIComponent(removalReason)
      );
    }
    return new Observable();
  }

  getUserTeacherFunction(schoolId: number, userId: number) {
    if (schoolId && userId) {
      return this.httpClient.get(schoolId + '/school/user/' + userId + '/teacher-function');
    }
    return new Observable();
  }

  updateUserTeacherFunction(schoolId: number, userId: number, isTeacher: boolean) {
    if (schoolId && userId) {
      return this.httpClient.put(
        schoolId + '/school/user/' + userId + '/teacher-function',
        {is_teacher: isTeacher}
      );
    }
    return new Observable();
  }

  inviteUserToSchool(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      body['school_id'] = school_id;
      return this.httpClient.post(school_id + '/school/inviteUser' , body);
    }
    return new Observable();
  }
  unsubscribe() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }
}
